























import pathToRegexp from 'path-to-regexp'
import { Component, Vue, Watch } from 'vue-property-decorator'
import LayoutRouter from '@/router/layout'
import { RouteRecord, Route } from 'vue-router'

@Component({
  name: 'Breadcrumb'
})
export default class extends Vue {
  private breadcrumbs: any[] = [];

  @Watch('$route')
  private onRouteChange() {
    const route = this.$route
    if (!route) return
    const meta = route.meta
    const path = route.path

    if (meta && meta.hidden) {
      const result = [..._forEach(LayoutRouter, [], meta.parentPath), route]
      this.breadcrumbs = result
    } else {
      const result = _forEach(LayoutRouter, [])
      this.breadcrumbs = result
    }

    function _forEach(data:any, result:any, parentPath:(string | null) = null) {
      const _path = parentPath || path
      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        if (item.path && item.path === _path) {
          result.push(item)
          break
        } else {
          if (item.children) {
            const _find = item.children.find((w:any) => w.path === _path)

            if (_find) {
              const _item = JSON.parse(JSON.stringify(item))
              delete _item.children
              result.push(_item)
              result.push(_find)
              break
            } else {
              result = []
            }
          } else {
            result = []
          }
        }
      }
      return result
    }
  }

  created() {
    this.onRouteChange()
  }
}
